export class PostalCodeValidation {
    public static validateJPPostalCode(value: string) {
        return /^\d{3}-\d{4}$/.test(value);
    }

    public static isOverSeasPostalCode(value: string) {
        if (value === '000-0000' || value === '0000000') {
            return true;
        }
        return false;
    }

    public static formatPostalCode(value: string) {
        let newValue = value.replace(/[^0-9\-]/g, '');
        if (PostalCodeValidation.validateJPPostalCode(value)) {
            return newValue;
        }

        if (/^\d{4,7}$/g.test(value)) {
            newValue = `${value.slice(0, 3)}-${value.slice(3, value.length)}`;
        }
        return newValue;
    }
}
